import MyAvatar from './MyAvatar'

export default MyAvatar
